import TerminalPdvService from "@/services/TerminalPdvService";

export const terminalPdv = {
  namespaced: true,
  state: {
    terminalPdv: {},
  },
  actions: {
    getTerminalPdv({ commit }, payload) {
      return TerminalPdvService.GetTerminalPdv(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    getAllTerminalPdv({ commit }) {
      return TerminalPdvService.GetAllTerminalPdv().then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    postTerminalPdv({ commit }, payload) {
      return TerminalPdvService.PostTerminalPdv(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    putTerminalPdv({ commit }, payload) {
      return TerminalPdvService.PutTerminalPdv(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    ativarTerminalPdv({ commit }, payload) {
      return TerminalPdvService.AtivarTerminalPdv(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    desativarTerminalPdv({ commit }, payload) {
      return TerminalPdvService.DesativarTerminalPdv(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    forcarCargaGeralTerminalPdv({ commit }, payload) {
      return TerminalPdvService.ForcarCargaGeralTerminalPdv(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    forcarCargaGeralTodosTerminalPdv({ commit }) {
      return TerminalPdvService.ForcarCargaGeralTodosTerminalPdv().then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    getPainelTerminalPdv({ commit }, payload) {
      return TerminalPdvService.GetPainel(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    getMovimentacoesTerminalPdv({ commit }, payload) {
      return TerminalPdvService.GetMovimentacoes(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
  },
  mutations: {},
};

export default terminalPdv;
